module.exports = __webpack_public_path__ + "static/media/arriva-logo-charcoal.e8728bcb.svg";